var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a6101c261f61d11aaf0f501da97201af6a9cdc9a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["wet_website@a45"]={id:"a6101c261f61d11aaf0f501da97201af6a9cdc9a"};
      